import React, { FC, useEffect, useState } from 'react'
import { BiChevronRight } from 'react-icons/bi'
import { useLocation } from 'react-router'
import { handleLabelNameChanges } from 'src/cms/helpers/automation'
import { checkIsActive } from '../../../helpers'
import {
  getMenuIcon,
  ASIDE_ACCENT,
  ASIDE_ACTIVE_BG,
  ASIDE_ICON_MUTED,
  ASIDE_TEXT,
} from './asideStyles'

type Props = {
  to: string
  title: string
}

const AsideMenuItemWithSub: FC<Props> = ({ children, to, title }) => {
  const { pathname } = useLocation()
  const [isOpen, setIsOpen] = useState(false)
  const isActive = checkIsActive(pathname, to)
  const Icon = getMenuIcon(title)

  useEffect(() => {
    if (isActive) {
      setIsOpen(true)
    }
  }, [pathname, isActive])

  const isHighlighted = isActive || isOpen

  const headerStyle: React.CSSProperties = {
    display: 'flex',
    alignItems: 'center',
    gap: 10,
    padding: '12px 16px',
    borderLeft: isHighlighted ? `4px solid ${ASIDE_ACCENT}` : '4px solid transparent',
    background: isHighlighted ? ASIDE_ACTIVE_BG : 'transparent',
    color: isHighlighted ? ASIDE_ACCENT : ASIDE_TEXT,
    fontSize: 14,
    fontWeight: isHighlighted ? 600 : 400,
    cursor: 'pointer',
    transition: 'background 0.15s, color 0.15s, border-left-color 0.15s',
  }

  return (
    <div data-cy={`${handleLabelNameChanges(title)}-menu`}>
      <div
        style={headerStyle}
        data-cy={`${handleLabelNameChanges(title)}-menu-link`}
        onClick={() => setIsOpen((prev) => !prev)}
      >
        <span
          style={{
            color: isHighlighted ? ASIDE_ACCENT : ASIDE_ICON_MUTED,
            flexShrink: 0,
            display: 'flex',
          }}
        >
          <Icon size={20} />
        </span>
        <span style={{ flex: 1 }}>{title}</span>
        <BiChevronRight
          size={18}
          style={{
            transition: 'transform 0.2s',
            transform: isOpen ? 'rotate(90deg)' : 'rotate(0deg)',
            color: isHighlighted ? ASIDE_ACCENT : ASIDE_ICON_MUTED,
          }}
        />
      </div>

      {isOpen && <div>{children}</div>}
    </div>
  )
}

export { AsideMenuItemWithSub }
